import axios from 'axios';
import { useEffect, useState } from 'react'
import Box from 'elements/Box';
import { Button, CircularProgress, IconButton, Pagination, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { Link, useParams } from 'react-router-dom';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import {ProjectConfig} from 'Global';
import moment from 'moment';
import AlertDialog from 'elements/AlertDialog';
import FiltersApplied from 'elements/Filters/FiltersApplied';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Cookies from 'universal-cookie';


const SantoralList = () => {

  const [loading, setLoading] = useState(false); 
  const [list, setList] = useState<any []>([]);
  const [total_pages, setTotalPages] = useState(0);

  const queryParams = new URLSearchParams(window.location.search);
  const currentPage=parseInt(localStorage.getItem('page') || "1");

  const [page, setPage] = useState(currentPage);
  const category = queryParams.get('category');
  const [refreshList, setRefreshList] = useState(0);
  const [order, setOrder] = useState(['name', 'asc'])
  

  /*=========================================================
  LOAD LIST            
  =========================================================*/

  useEffect(() => {
    
      axios.get(ProjectConfig.api_url,
      {
        params: {
          request: 'santoral_list',
          filters: filtersValues,
          page: page,
          order: order
        }
      })
        .then((response) => {
          console.log("ul ",response.data); 
          setList(response.data.list)
          setTotalPages(response.data.total_pages)
          setLoading(true)
           
        })
        .catch((err) => {
          console.log(err.data);
        })
        localStorage.setItem('page', page.toString())
    
  }, [page, refreshList, order])
  /*=========================================================*/



  /*=========================================================
  DELETE ITEM
  =========================================================*/

  const handleDelete = (id:number) => {
    setActiveItem(id)
    setOpenAlert(true)
  }

  const deleteItem = () => {
    axios.post(ProjectConfig.api_url, null, 
      {
        params: {
          request: 'delete_santoral',
          id: activeItem,
        }
      })
  
      .then((response) => {
        console.log(response.data);
        setRefreshList(refreshList + 1)
        
      })
      .catch((err) => {
        console.log(err.data);
      })
      .then(() => {
        setOpenAlert(false)
      })
  }
  /*=========================================================*/

// call global snackbar
  
  const [openAlert, setOpenAlert] = useState(false);
  const [activeItem, setActiveItem] = useState<any>(null);
  const [textoEscrito, setTextoEscrito] = useState('');

  const [filtersValues, setFiltersValues] = useState<any>({});
  

  function handleInputChange(event:any) {
    const nuevoTexto = event.target.value;
    setTextoEscrito(nuevoTexto);


    filtersValues.texto = event.target.value;
    setPage(1);
    axios.get(ProjectConfig.api_url,
      {
        params: {
          request: 'santoral_list',
          filters: filtersValues,
          page: page,
          order: order,

        }
      })
      .then((response) => {
        setList(response.data.list)
        setTotalPages(response.data.total_pages)




      })
      .catch((err) => {
        console.log(err.data);
      })
    localStorage.setItem('page', page.toString())
  }

  const handleMouseEnter = () => {
    // Cambiar el cursor cuando el mouse entra en el título
    document.body.style.cursor = "pointer";
  };

  const handleMouseLeave = () => {
    // Restaurar el cursor cuando el mouse sale del título
    document.body.style.cursor = "default";
  };
  
  const [order_name, setOrder_name] = useState(true)
  const [order_fecha, setOrder_fecha] = useState(false)
  const [order_fecha_cre, setOrder_fecha_cre] = useState(false)
  function name_order()
  {
    if(order[0] == 'name')
    {
      if(order[1] == 'asc'){
        setOrder(['name', 'desc']);
        flecha('titulo', true);
      }else if(order[1] == 'desc'){
        setOrder(['name', 'asc']);
        flecha('titulo', false);
      }
    }else{
      setOrder(['name', 'asc']);
      flecha('titulo', false);
    }
  }

  function fecha_order()
  {
    if(!order_fecha)
    {
      setOrder(['month ASC', ',day ASC']);
      setOrder_fecha(true);
      flecha('fecha', true);
    }if(order_fecha)
    {
      setOrder(['month DESC', ',day DESC']);
      setOrder_fecha(false);
      flecha('fecha', false);
    }

  }

  function fecha_cre()
  {
    if(!order_fecha_cre)
    {
      setOrder(['created_at', 'ASC']);
      setOrder_fecha_cre(true);
      flecha('creacion', true);
    }if(order_fecha_cre)
    {
      setOrder(['created_at', 'DESC']);
      setOrder_fecha_cre(false);
      flecha('creacion', false);
    }

  }

  const [flecha_ord, setFlecha_ord] = useState('')

  function flecha(flecha:String, dir:Boolean)
  {
    if('titulo' == flecha){
        if(dir)
        {
          setFlecha_ord('titulo_desc')
        }else{
          setFlecha_ord('titulo_asc')
        }
    }

    if('fecha' == flecha){
        if(dir)
        {
          setFlecha_ord('fecha_desc')
        }else{
          setFlecha_ord('fecha_asc')
        }
    }

    if('creacion' == flecha){
        if(dir)
        {
          setFlecha_ord('creacion_desc')
        }else{
          setFlecha_ord('creacion_asc')
        }
    }
    
  }
  
  
  const [maintenanceLoading, setMaintenanceLoading] = useState(false);
  const [dryRunCertified, setDryRunCertified] = useState(false);
  const [preflightToken, setPreflightToken] = useState('');
  const [maintenanceMessage, setMaintenanceMessage] = useState('');

  const maintenanceRequest = async (
    request: 'santoral_refresh_dry_run' | 'santoral_refresh_apply',
    confirmation?: string,
    certifiedPreflightToken?: string
  ) => {
    const token = new Cookies().get('ltkn') || '';

    return axios.post(
      ProjectConfig.api_url,
      {
        request,
        ...(confirmation ? { confirmation } : {}),
        ...(certifiedPreflightToken
          ? { preflight_token: certifiedPreflightToken }
          : {}),
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        timeout: 600000,
      }
    );
  };

  const reportSummary = (payload: any) => {
    const report = payload?.report || {};
    const summary = report?.summary || {};
    const projected = report?.projected_certification || {};

    return [
      `Estado: ${payload?.certified ? 'CERTIFICADO' : 'NO CERTIFICADO'}`,
      `Transacción: ${report?.transaction || 'sin dato'}`,
      `DELETE: ${summary?.deletions ?? report?.deletions ?? 'sin dato'}`,
      `Actualizados: ${summary?.updated_existing ?? 0}`,
      `Agregados universales: ${summary?.added_universal ?? 0}`,
      `Agregados Colombia: ${summary?.added_colombia ?? 0}`,
      `Clonados para conservar calendarios: ${summary?.cloned_rows ?? 0}`,
      `Biografías completadas: ${summary?.biographies_completed_existing ?? 0}`,
      `Imágenes preparadas: ${summary?.images_prepared ?? 0}`,
      `Certificación proyectada: ${projected?.pass ? 'PASS' : 'FAIL'}`,
    ].join(' · ');
  };

  const runSantoralDryRun = async () => {
    setMaintenanceLoading(true);
    setDryRunCertified(false);
    setPreflightToken('');
    setMaintenanceMessage('Ejecutando dry-run certificado...');

    try {
      const response = await maintenanceRequest('santoral_refresh_dry_run');
      const payload = response.data;

      if (!payload?.certified || !payload?.preflight_token) {
        throw new Error(
          'El servidor no emitió un preflight certificado válido.'
        );
      }

      setPreflightToken(payload.preflight_token);
      setDryRunCertified(true);
      setMaintenanceMessage(reportSummary(payload));
    } catch (error: any) {
      setMaintenanceMessage(
        error?.response?.data?.message
          || error?.message
          || 'Falló el dry-run del Santoral.'
      );
    } finally {
      setMaintenanceLoading(false);
    }
  };

  const applySantoralRefresh = async () => {
    if (!dryRunCertified || !preflightToken) {
      setMaintenanceMessage(
        'Primero debe pasar el dry-run certificado en esta sesión.'
      );
      return;
    }

    const confirmed = window.confirm(
      'Se aplicará la actualización sobre el mismo estado certificado por el dry-run. La transacción volverá a validar todo antes del COMMIT y mantendrá DELETE=0. ¿Continuar?'
    );

    if (!confirmed) {
      return;
    }

    const tokenToConsume = preflightToken;
    setMaintenanceLoading(true);
    setDryRunCertified(false);
    setPreflightToken('');
    setMaintenanceMessage(
      'Aplicando sobre el estado certificado y validando antes del COMMIT...'
    );

    try {
      const response = await maintenanceRequest(
        'santoral_refresh_apply',
        'APLICAR_SANTORAL_ES',
        tokenToConsume
      );
      const payload = response.data;

      if (!payload?.certified) {
        throw new Error('El servidor no certificó la aplicación.');
      }

      setMaintenanceMessage(reportSummary(payload));
      setRefreshList(refreshList + 1);
    } catch (error: any) {
      setMaintenanceMessage(
        error?.response?.data?.message
          || error?.message
          || 'Falló la aplicación del Santoral.'
      );
    } finally {
      setMaintenanceLoading(false);
    }
  };

  return (
    <div id='ProductList'>
      
      <div className='buttons_top'>
        <Button component={Link} to="/admin/santoral/catalogo/hsf" variant="outlined">Hijos de la Sagrada Familia</Button>
        <Button component={Link} to="/admin/santoral/catalogo/martyrology" variant="outlined">Martirologio Romano</Button>
        <Button component={Link} to="add" variant="contained">
          Nuevo Santo
        </Button>

        <Button
          variant="outlined"
          onClick={runSantoralDryRun}
          disabled={maintenanceLoading}
        >
          {maintenanceLoading ? 'Procesando...' : 'Certificar dry-run'}
        </Button>

        <Button
          variant="contained"
          color="success"
          onClick={applySantoralRefresh}
          disabled={
            maintenanceLoading
            || !dryRunCertified
            || !preflightToken
          }
        >
          Aplicar actualización
        </Button>

          <input
          type="text"
          style={{
            fontSize: '12px',
            textAlign: 'left',
            width: '200px',
          }}
          placeholder="Buscar"
          onChange={handleInputChange}
        />

      </div>
      {maintenanceMessage && (
        <div
          style={{
            margin: '10px 0 16px',
            padding: '10px 12px',
            border: '1px solid #d0d0d0',
            borderRadius: '6px',
            fontSize: '13px',
            lineHeight: 1.5,
          }}
        >
          {maintenanceMessage}
        </div>
      )}
        <div id="task_list_container" className="flex_container">
          
            <Box id='user_list' title="Santoral" subtitle="Lista"  >
            {!loading && <div id='loader'><CircularProgress /></div>}

            

            <TableContainer>
            <Table stickyHeader aria-label="sticky table"> 
              <TableHead>
                <TableRow>
                  <TableCell onClick={() => name_order()} 
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave} style={{ width: '50%' }}>Nombre
                  {flecha_ord === 'titulo_desc' && (
                    <KeyboardArrowDownIcon  />
                  )}
                  {flecha_ord === 'titulo_asc' && (
                    <KeyboardArrowUpIcon  />
                  )}
                  </TableCell>
                  <TableCell onClick={() => fecha_order()}
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave} style={{ width: '20%' }}>Fecha del santo
                  {flecha_ord === 'fecha_desc' && (
                      <KeyboardArrowUpIcon  />
                    )}
                    {flecha_ord === 'fecha_asc' && (
                      <KeyboardArrowDownIcon  />
                    )}
                  </TableCell>
                  
                  <TableCell onClick={() => fecha_cre()}
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave} style={{ width: '20%' }}>Creacion
                  {flecha_ord === 'creacion_desc' && (
                    <KeyboardArrowDownIcon  />
                  )}
                  {flecha_ord === 'creacion_asc' && (
                    <KeyboardArrowUpIcon  />
                  )}
                  </TableCell>
                  <TableCell style={{ width: '10%' }}></TableCell>
                  {/* <TableCell></TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                  {list.map((list_item,i) => (
                    <TableRow 
                      
                      key={i}
                      hover
                      role="checkbox"
                    >
                      <TableCell onClick={()=> {window.location.href = `/admin/santoral/edit/${list_item.santoral_id}`}} >    
                        <div className='flexWImage'>
                          <img className='ListImage' src={list_item.image} />
                          <div className="flexWImage_right">
                          {list_item.name}
                          </div>
                        </div>
                        
                      </TableCell>

                     
                      <TableCell>
                         {list_item.day} / {list_item.month} 
                      </TableCell>
                      <TableCell>
                         {list_item.created_at}
                      </TableCell>

                      <TableCell> 
                        <IconButton aria-label="delete"  color="primary" onClick={() => handleDelete(list_item.santoral_id)}>
                          <DeleteOutlineOutlinedIcon />
                        </IconButton>
                    </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          
          <Pagination count={total_pages} page={page}  onChange={(event, value) => {
            setPage(value)
          }
          } 
          color="primary"
          style={{"marginTop": "20px","alignSelf": "center"}}
          />
          </Box>
 
        </div>

        <AlertDialog
            open={openAlert}
            setOpen={setOpenAlert}
            send={deleteItem}
        />
    </div>
  );
};



export default SantoralList;
